module.exports = __webpack_public_path__ + "static/media/cityAndCountryBike.42ddfd90.png";